import { atom } from 'jotai';

// Desktop sidebar: true = expanded labels, false = icon rail.
// The temporary mobile drawer uses its own local open state.
export const isDrawerExpandedAtom = atom(true);
